import { render, staticRenderFns } from "./CustomerAlertsModal.vue?vue&type=template&id=31872294&"
import script from "./CustomerAlertsModal.vue?vue&type=script&lang=js&"
export * from "./CustomerAlertsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports